import MoneyMgmtTestTopicList from "../../extra_credit/Datasets/money_mgmt_test_topic_list";

export const summarizeTestByTopic = (questionAnswerArr) => {
    questionAnswerArr = questionAnswerArr.sort((a, b) => 
        (a.questionNbr + a.user > b.questionNbr + b.user) ? 1 : -1);
    const topicList = MoneyMgmtTestTopicList;
    let prevTopic = "";
    let topicObj = {};
    let topicArr = [];
    let prevUser = "";
    let totalObj = {topic: "Test Totals", topicAbbrev: "TT", sortOrder: 9,
                nbrTests: 0, nbrQuestions: 0, partialCorrect: 0, nbrCorrect: 0, 
                nbrPlayers: 0};
    for (let i=0; i<questionAnswerArr.length; i++){
        const questionTopic = questionAnswerArr[i].questionNbr.split('-')[0];
        let topicIndx = -1;
        if (prevTopic !== questionTopic){
            if (prevTopic !== ""){
                topicArr.push(topicObj);
                totalObj.nbrTests += topicObj.nbrTests;
                totalObj.nbrQuestions += topicObj.nbrQuestions;
                totalObj.partialCorrect += topicObj.partialCorrect;
                totalObj.nbrCorrect += topicObj.nbrCorrect;
                totalObj.nbrPlayers += topicObj.nbrPlayers; 
            }
            prevTopic = questionTopic;
            topicIndx = topicList.findIndex(elem => elem.abbrev === questionTopic);
            let topicAbbrev = questionTopic;
            let topic = "";
            if (topicIndx === -1){
                topic = "Unknown Topic";
            }else{
                topic = topicList[topicIndx].testTopic;
            }
            topicObj = {topic: topic, topicAbbrev: topicAbbrev, sortOrder: topicList[topicIndx].sortOrder,
                nbrTests: 0, nbrQuestions: 0, partialCorrect: 0, nbrCorrect: 0, 
                nbrPlayers: 0};
        }
        topicObj.nbrTests += 1;
        topicObj.nbrQuestions += 1;
        let fullyCorrect = false;
        if (+questionAnswerArr[i].correct === 1){
            topicObj.nbrCorrect += 1;
            fullyCorrect = true;
        }
        if (+questionAnswerArr[i].correct > 0 && fullyCorrect === false){
            topicObj.partialCorrect += 1;
        }
        if (questionAnswerArr[i].user !== prevUser){
            topicObj.nbrPlayers += 1;
            prevUser = questionAnswerArr[i].user;
        }
    }
    if (prevTopic !== ""){
        topicArr.push(topicObj);
        totalObj.nbrTests += topicObj.nbrTests;
        totalObj.nbrQuestions += topicObj.nbrQuestions;
        totalObj.partialCorrect += topicObj.partialCorrect;
        totalObj.nbrCorrect += topicObj.nbrCorrect;
        totalObj.nbrPlayers += topicObj.nbrPlayers; 
    }
    topicArr.push(totalObj);
    topicArr.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : -1);
    return topicArr;
}
export default summarizeTestByTopic;